import { render, staticRenderFns } from "./CardMetrica.vue?vue&type=template&id=700932c1&scoped=true&"
import script from "./CardMetrica.vue?vue&type=script&lang=js&"
export * from "./CardMetrica.vue?vue&type=script&lang=js&"
import style0 from "./CardMetrica.vue?vue&type=style&index=0&id=700932c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700932c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VCard,VIcon,VProgressLinear})
